import {AuditService} from "../PA.Core/Security/AuditService";
import {CustomerBO} from "./CustomerBO";
import {AuditUtils, IAuditField} from "../PA.Core/Basic/AuditUtils";
import {esWB_Customer, esWB_Customer_Hierarchy, esWB_Product_Group} from "../PA.Core/PAdbSchema";


export class CustomerBOAudit {

    // Audit Log Service for Product

    static async CustomerAuditBO(CustomerBO: CustomerBO): Promise<AuditService> {
        const self = CustomerBO
        const auditService = new AuditService(self.dbContext)
        auditService.setReference("Customer", self.drWB_Customer.cif.WB_CUST_ID)
        // @ts-ignore
        self.deleteKeys = self.deleteKeys || {}
        // @ts-ignore
        let deleteKeys: any = self.deleteKeys

        //Adding new Customer on screen
        const customerParams: IAuditField [] = [
            {fieldName: "CUSTOMER_NAME", realName: "Name", bAllMsg: true}, //create
            {fieldName: "PLANNING_CUSTOMER_IND", realName: "Planning Customer"},
            {fieldName: "CUSTOMER_TYPE", realName: "Customer Type", domainId: "Customer_Type"},
        ]



        // Parent Hierarchy
        const custParentHierarchyParams: IAuditField [] = [
            {fieldName: "WB_CUST_ID_PRNT", realName: `Customer Parent Hierarchy`, fkMapper: esWB_Customer, fkMapperNameField: "CUSTOMER_NAME", fkMapperIdField:"CUSTOMER_ID", bAllMsg: true},
            {
                fieldName: "WB_CUSTH_ID",
                realName: "Hierarchy Type",
                fkMapper: esWB_Customer_Hierarchy,
                fkMapperNameField: "WB_CUST_HIER_ID",
                fkMapperIdField: "WB_CUSTH_ID",

            },
            {fieldName: "EFFECTIVE_START_DT", realName: "Effective Start Date"},
            {fieldName: "EFFECTIVE_END_DT", realName: "Effective End Date"},
        ]
        // Children Hierarchy
        const custChildrenHierarchyParams: IAuditField [] = [
            {fieldName: "WB_CUST_ID", realName: `Customer Children Hierarchy,`, fkMapper: esWB_Customer, fkMapperNameField: "CUSTOMER_NAME", fkMapperIdField:"WB_CUST_ID", bAllMsg: true},
            {
                fieldName: "WB_CUSTH_ID",
                realName: "Hierarchy Type",
                fkMapper: esWB_Customer_Hierarchy,
                fkMapperNameField: "WB_CUST_HIER_ID",
                fkMapperIdField: "WB_CUSTH_ID",

            },
            {fieldName: "EFFECTIVE_START_DT", realName: "Effective Start Date"},
            {fieldName: "EFFECTIVE_END_DT", realName: "Effective End Date"},
        ]





        // Customer Distribution Relationship Row
        const custDistRelParams: IAuditField [] = [
            {fieldName: "WB_PRDGRP_ID", realName: `Wholesaler`, fkMapper: esWB_Product_Group, fkMapperNameField: "PRODUCT_GROUP_NAME", fkMapperIdField:"WB_PRDGRP_ID", bAllMsg: true},
            {fieldName: "RELATIONTYPE", realName: "Relation"},
            {fieldName: "RATE", realName: "Rate", decimalCount: 2},
            {fieldName: "EFFECTIVE_START_DT", realName: "Effective Start Date"},
            {fieldName: "EFFECTIVE_END_DT", realName: "Effective End Date"},
        ]


        await AuditUtils.logRecord(auditService, self.drWB_Customer, customerParams,{objectName: 'Customer', deletedKeys: deleteKeys})

        // Parent Hierarchy
        for (let aCustPrntHierRow of self.drWB_Customer.WB_CustomerRelationshipRows_Parents) {
            await AuditUtils.logRecord(auditService, aCustPrntHierRow, custParentHierarchyParams, {
                objectName: 'Parent Hierarchy',
                deletedKeys: deleteKeys,

            })
        }

        // Children Hierarchy

        for (let aCustChildHierRow of self.drWB_Customer.WB_CustomerRelationshipRows_Children) {
            await AuditUtils.logRecord(auditService, aCustChildHierRow, custChildrenHierarchyParams, {
                objectName: 'Children Hierarchy',
                deletedKeys: deleteKeys,
            })
        }




        // Customer Distribution Relationship Row
        for (let aCustDistRelRow of self.drWB_Customer.WB_CustomerDistributionRelationshipRows) {

            await AuditUtils.logRecord(auditService, aCustDistRelRow, custDistRelParams, {
                objectName: 'Customer Distribution Relationship',
                deletedKeys: deleteKeys,
            })

        }
        return auditService;
    }

}